import { Link } from 'react-router-dom';
import { categories } from '@/mocks/siteData';

export default function CategoryGrid() {
  return (
    <section className="w-full bg-background-100 py-16" aria-labelledby="cat-title">
      <div className="max-w-[1280px] mx-auto px-4 md:px-6 lg:px-8">
        <div className="text-center mb-10">
          <h2 id="cat-title" className="font-heading text-2xl md:text-3xl font-bold text-foreground-900">
            探索分类
          </h2>
          <p className="text-sm text-foreground-500 mt-2">按地区和类型浏览你感兴趣的亚洲视频内容</p>
        </div>

        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-5 gap-4">
          {categories.map((cat) => (
            <Link
              key={cat.slug}
              to={`/category/${cat.slug}`}
              className="group bg-white rounded-xl border border-background-200 p-6 hover:border-background-300 transition-all duration-300 cursor-pointer flex flex-col items-center text-center"
            >
              <div className="w-14 h-14 rounded-full bg-primary-50 flex items-center justify-center mb-4 group-hover:bg-primary-100 transition-colors">
                <i className={`${cat.icon} text-xl text-primary-600`}></i>
              </div>
              <h3 className="font-heading text-base font-semibold text-foreground-900 mb-1.5">
                {cat.name}
              </h3>
              <p className="text-xs text-foreground-500 leading-relaxed mb-3">
                {cat.description}
              </p>
              <span className="text-xs text-primary-600 font-medium">
                {cat.count.toLocaleString()} 部内容
              </span>
            </Link>
          ))}
        </div>
      </div>
    </section>
  );
}